<template>
    <div> 
        <v-toolbar :height="height?height:'52'"  
            @click="ON_SEARCH(pricing_tier)" :rounded="rounded" dark flat 
            :color="LocalCashup?'primary':'grey darken-1'" 
            class="pa-0">
            <v-layout justify-center align-center>
                <v-autocomplete  class="mr-2 mt-1"
                    ref="ref_search_item"
                    v-model="search_item"
                    :disabled="inputLoading || !LocalCashup|| !pricing_tier"
                    :items="ItemsFiltered" dense
                    append-icon="search"
                    :prepend-inner-icon="vs.smAndDown?'search':''"
                    outlined :rounded="false"
                    :label="pricing_tier?'Search for Item':'You Must Pricing Tier First'"
                    color="blue-grey lighten-2" 
                    item-text="name"
                    item-value="key" 
                    :filter="(item, queryText, itemText) => { 
                        let index = (a,b)=>{
                                if(!a||!b){return false}
                                a = ''+a; b = ''+b
                                return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                            } 
                            let first = index(itemText,queryText)
                            let second = item?index(item.code,queryText):false
                            let third = item?index(item.brand_name,queryText):false
                            let forth = item?index(item.category_name,queryText):false
                            if(!item){return first}  
                            return first || second || third || forth 
                    }"
                    >
                    <template v-slot:selection="data">
                        {{ data.item.name }} 
                    </template>
                    <template v-slot:item="data">
                        <template v-if="(typeof data.item !=='object')" >
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                            <v-list-item-avatar tile color="grey" >
                                <img :src="data.item.image" v-if="data.item.image">
                                <v-icon v-else>local_offer</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content >
                                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                <v-list-item-subtitle v-html="data.item.code_"></v-list-item-subtitle>
                                <v-list-item-subtitle v-html="data.item.category_name"></v-list-item-subtitle>
                                <v-list-item-subtitle v-html="data.item.brand_name"></v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action v-if="pricing_tier">
                                <div> 
                                    <small>MWK</small> {{ MBS.actions.money(data.item[pricing_tier.key+"_"]) }}
                                </div>
                                <!-- <div> 
                                    <small>Stock</small> {{ data.item[CurrentOutlet.key+"_number_quantity"] }}
                                </div> -->
                            </v-list-item-action> 
                        </template>
                    </template>
                    <template v-slot:append v-if="vs.smAndDown">
                        <v-btn @click="ON_ITEM_ACTION" style="top: -4px; right: -8px;" min-width="38"  class="ma-0 px-0" color="b2">
                            <v-icon color="primary">mdi-view-grid-outline</v-icon>
                        </v-btn>
                    </template>
                </v-autocomplete>  

                <!-- //IF CARD -->
                <v-menu   v-if="selected_card"
                    v-model="menu_selected_card"
                    :close-on-content-click="true" 
                    offset-y  offset-overflow
                    :nudge-width="90" rounded="xl"
                    >
                    <template v-slot:activator="{ on, attrs }" >   
                        <v-btn  v-on="on" outlined class="mr-2 mb-1 pr-0"  > 
                            <v-icon>mdi-credit-card-scan </v-icon>
                            <v-icon class="ml-2 ">arrow_drop_down</v-icon>
                        </v-btn>  
                    </template> 

                    <v-card  v-if="ud"  
                        color="lighten-1" class="">  
                        <v-card-title class="secondary white--text py-" dark>
                            Selected Card
                        </v-card-title> 
                        <v-list dense> 
                            <div v-if="selected_card">
                                <v-list-item>Card Holder: {{selected_card.customer_name}}</v-list-item> 
                                <v-list-item>Card Number: {{selected_card.code}}</v-list-item> 
                                <v-list-item>Expire Date: {{selected_card.card_expire_date}}</v-list-item> 
                                <v-list-item>Balance: MWK{{MBS.actions.money(selected_card.balance_amount)}}</v-list-item> 
                            </div>
                            <v-divider /> 
                            <v-list-item :class="'secondary--text text-center'" @click="DESELECT_CARD">
                                <v-layout justify-center>
                                    Clear
                                </v-layout>
                            </v-list-item> 
                        </v-list>  
                    </v-card>  
                </v-menu>  
                
                <!-- //IF ORDER -->
                <v-menu   v-if="item_order"
                    v-model="menu_item_order"
                    :close-on-content-click="true" 
                    offset-y  offset-overflow
                    :nudge-width="90" rounded="xl"
                    >
                    <template v-slot:activator="{ on, attrs }" >   
                        <v-btn  v-on="on" outlined class="mr-2 mb-1 pr-0"  > 
                            <span v-if="item_order?.order_type =='quotation'">
                                <v-icon v-if="edit_order_items">mdi-text-box-edit</v-icon>
                                <v-icon v-else>mdi-text-box</v-icon> 
                            </span>
                            <span v-else>
                                <v-icon v-if="edit_order_items">mdi-square-edit-outline</v-icon>
                                <v-icon v-else>mdi-cart</v-icon> 
                            </span>
                            <v-icon class="ml-2 ">arrow_drop_down</v-icon>
                        </v-btn>  
                    </template> 

                    <v-card  v-if="ud"  
                        color="lighten-1" class="">  
                        <v-card-title class="secondary white--text py-" dark>
                            Selected Order Options 
                        </v-card-title> 
                        <v-list dense>  
                            <v-list-item v-if="item_order?.order_type !='quotation' && edit_order_items" @click="edit_order_items=false">
                                <v-list-item-action><v-icon>mdi-pencil-off-outline</v-icon></v-list-item-action> 
                                <v-list-item-content>Cancel Order Editing</v-list-item-content> 
                            </v-list-item> 
                            <v-list-item v-if="!edit_order_items" @click="CONFIRM_EDIT_ORDER_ITEMS(item_order)">
                                <v-list-item-action><v-icon>edit</v-icon></v-list-item-action> 
                                <v-list-item-content>Edit Order</v-list-item-content> 
                            </v-list-item>  
                            <v-list-item v-if="item_order?.order_type !='quotation'" @click="PRINT_ITEM_ORDERS({
                                order:item_order
                            })">
                                <v-list-item-action><v-icon>print</v-icon></v-list-item-action> 
                                <v-list-item-content>Print Order</v-list-item-content> 
                            </v-list-item>  
                            <v-list-item v-if="item_order?.order_type !='quotation'" @click="CONFIRM_DELETE_ITEM_ORDER({
                                order:item_order,
                                deleting_reason:'user_delete',
                                notify:true
                            })">
                                <v-list-item-action><v-icon>mdi-delete</v-icon></v-list-item-action> 
                                <v-list-item-content>Delete Order</v-list-item-content> 
                            </v-list-item> 
                            <v-divider/> 
                            <v-list-item v-if="item_order?.order_type !='quotation'" :class="'secondary--text text-center'" @click="CLEAR_ALL_DATA()">
                                <v-layout justify-center>
                                    Deselect Order
                                </v-layout>
                            </v-list-item> 
                            <v-list-item v-if="item_order?.order_type =='quotation'" :class="'secondary--text text-center'" @click="CLEAR_ALL_DATA()">
                                <v-layout justify-center>
                                    Deselect Quotation
                                </v-layout>
                            </v-list-item> 
                        </v-list>  
                    </v-card>  
                </v-menu>  
                
                <v-menu  
                    v-model="menu_pricing_tier"
                    :close-on-content-click="true" 
                    offset-y  offset-overflow
                    :nudge-width="90" rounded="xl"
                    >
                    <!-- :disabled="CompanySettings?CompanySettings.only_retail_model||CompanySettings.only_wholesale_model:false"   -->
                    <template v-slot:activator="{ on, attrs }">  
                        <v-btn :small="vs.smAndDown" height="38"  v-on="on" class=" m-1"
                            ref="btn_selling_mode"
                                color="secondary">
                            {{pricing_tier?pricing_tier.name:'Select'}}
                            <v-icon class="ml-2">arrow_drop_down</v-icon>
                        </v-btn> 
                    </template> 

                    <v-card  v-if="ud"  
                        color="lighten-1" class="">  
                        <v-card-title class="secondary white--text py-" dark>
                            Select Pricing Tier 
                        </v-card-title> 
                        <v-list dense> 
                            <div v-for="(pricing,index) in TillPricingTiers" :key="index">
                                <v-list-item 
                                    :class="pricing == pricing_tier?'secondary--text':''" 
                                    @click="pricing_tier=pricing">
                                    {{pricing?pricing.name:'...'}}
                                </v-list-item> 
                            </div>
                        </v-list>  
                    </v-card>  
                </v-menu>   
            </v-layout>
        </v-toolbar>   
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex"   
    
    const PAGE_NAME = "SALE-SEARCH"

    export default {
        props:['height','selected_card','item_order','rounded'],
        data(){
            return{
                show:false,     
                inputLoading:false,     
                menu_pricing_tier:false,  
                pricing_tier:null,
                search_item:null,

            }
        },
        created(){ 
            try { 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  
            this.INITIALIZE_PRICING_TIER()
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint 
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                tus: state=> state.users["TEMPORARY_USER"], 
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
                K_CONNECTOR: state=> state.items['K_CONNECTOR'],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                Tills: state=> state.items[(DATA.ITEMS.TILLS.values).toUpperCase()],
                JoinedTills: state=> state.join[(DATA.ITEMS.TILLS.values).toUpperCase()], 

                LocalCashups: state=> state.locals[(DATA.ITEMS.LOCAL_CASHUPS.values).toUpperCase()],
                
            }), 
            ItemsData(){
                const Items = this.Items
                const JoinedItems = this.JoinedItems  
                return JoinedItems?JoinedItems:Items
            }, 
            ItemsFiltered(){
                const items = this.ItemsData
                const departments = this.selected_departments
                const categories = this.FilteredItemCategories 
                if(!items){return null}
                if(!this.MBS.actions.SIZE(departments)){return items}
                let filtered = items.filter(item=>{
                    let index = departments?departments.indexOf(item.item_department_code):0
                    let index2 = categories?categories.findIndex(category=>category.code == item.category_code):0
                    return (index!=-1)||(index2!=-1)
                })
                return filtered

            }, 
            TillsData(){
                return this.JoinedTills?this.JoinedTills:this.Tills
            }, 
            CurrentTill(){
                let tills = this.TillsData
                let cashup = this.LocalCashup  
                if(!tills || !cashup){return null}
                let filled = tills.find(item=>{
                    return item.key == cashup.till_key
                })   
                return filled
            },

            LocalCashup(){    
                let cashups = this.LocalCashups 
                let local_cashup = cashups?cashups.find(item=>{
                    return !item.closed
                }):null 
                this.day_shift_key = local_cashup?.day_shift_key 
                return local_cashup
            }, 
            AllActionItems(){  
                return [ 
                    {
                        icon:"mdi-gesture-tap-hold",
                        action:"click_mode", 
                        name:"Click Mode",
                        color:"green",
                        type:"sales"
                    },{
                        icon:"mdi-refresh",
                        action:"refresh_data", 
                        name:"Refresh",
                        color:"secondary",
                        type:""
                    },
                    { 
                        icon:"remove_shopping_cart",
                        action:"clear_sales", 
                        name:"Clear",
                        color:"red",
                        type:"sales"
                    },{ 
                        icon:"shopping_cart",
                        action:"view_orders", 
                        name:"Order(s)",
                        color:"yellow",
                        type:"sales",
                        menu:{
                            name:"Orders",
                            items:[
                                {icon:"mdi-cart",action:"view_orders",name:"Orders List"}, 
                                {icon:"mdi-cart-heart",action:"view_customers_orders",name:"Customer Orders"},
                                {icon:"mdi-cash-register",action:"view_assistant_till_orders",name:"Assistant Till Orders", show:(this_)=>this_.HasAssistant},
                                {icon:"mdi-table-chair",action:"view_table_orders",name:"Table Orders", show:(this_)=>this_.IsRestaurant},
                                {icon:"mdi-face-agent",action:"view_waiter_orders",name:"Waiter Orders", show:(this_)=>this_.IsRestaurant},
                            ]
                        },
                        indicator:{ 
                            value_text:(this_,field,data)=>{
                                const NewOrders = data?.NewItemOrders?.new_items
                                const size = this_.MBS.actions.SIZE(NewOrders)
                                return size+" New Order(s)"
                            },
                            value:(this_,field,data)=>{
                                const NewOrders = data?.NewItemOrders?.new_items
                                const size = this_.MBS.actions.SIZE(NewOrders)
                                return size>10?"10+":size
                            },
                            show:(this_,field,data)=>{
                                const NewOrders = data?.NewItemOrders?.new_items
                                const size = this_.MBS.actions.SIZE(NewOrders)
                                return size?true:false
                            },
                            color:"green"
                        }
                    },{ 
                        icon:"mdi-archive-arrow-down-outline",
                        action:"open_drawer", 
                        name:"Drawer",
                        color:"blue",
                        type:"sales",
                        show:(this_)=>!this_.Assistant
                    },
                    // { 
                    //     action:"settings", 
                    //     name:"Settings",
                    //     color:"",
                    //     type:"sales"
                    // }, 
                    { 
                        icon:"mdi-clipboard-text-clock",
                        action:"history", 
                        name:"History", 
                        color:"", 
                        type:"sales",
                        show:(this_)=>!this_.Assistant,
                        menu:{
                            name:"Histories",
                            items:[
                                {icon:"mdi-cart-check",action:"history_sales",name:"Sales"},
                                {icon:"mdi-cart-off",action:"history_return_sales",name:"Returned Sales"},
                                {icon:"mdi-cash-check",action:"history_return_sales",name:"Paid Invoices"},
                                {icon:"mdi-text-box-multiple-outline",action:"history_return_sales",name:"Issued Quotations"},
                                // {icon:"mdi-sun-clock",action:"history_cashups",name:"Dayshifts"}, 
                                // {icon:"mdi-cash-clock",action:"history_dayshifts",name:"Cashups"},  
                            ]
                        }
                    }, 
                    { 
                        icon:"content_copy",
                        action:"last_print", 
                        name:"Duplicate", 
                        color:"", 
                        type:"sales",
                        no_fiscal_printer:true,
                        show:(this_)=>!this_.Assistant
                    },  
                    { 
                        icon:"mdi-clipboard-text-clock",
                        action:"receive_payment", 
                        name:"Receive Payment", 
                        color:"", 
                        type:"sales",
                        show:(this_)=>!this_.Assistant
                    }, 
                    { 
                        icon:mdiTextBoxSearch,
                        action:"find_receipt", 
                        name:"Find", 
                        color:"", 
                        type:"sales"
                    },   
                    { 
                        icon:"mdi-cart-off",
                        action:"sales_return", 
                        name:"Sales Return", 
                        color:"", 
                        type:"sales",
                        show:(this_)=>!this_.Assistant
                    },  
                    { 
                        icon:"mdi-file-table-box",
                        action:"add_new_customer", 
                        name:"Inventory", 
                        color:"pink darken-4", 
                        menu:{
                            name:"Manage Inventory",
                            items:[
                                {icon:"mdi-file-table-box-outline",action:"view_inventory",name:"View Inventory"},
                                {icon:mdiInvoiceTextPlusOutline,action:"stock_requisition",name:"Stock Requisition"},
                                {icon:"mdi-transfer",action:"transfer_stock",name:"Transfer Stock"}, 
                                {icon:mdiInvoiceCheckOutline,action:"verify_stock",name:"Verify Stock"}, 
                                {icon:"mdi-contrast-box",action:"stock_control",name:"Stock Control"}, 
                                {icon:"mdi-cog-transfer",action:"adjust_stock",name:"Adjust Stock"}, 
                            ]
                        }
                    },
                    
                    { 
                        icon:"$money-check-dollar",
                        action:"add_new_customer", 
                        name:"Expenses", 
                        color:"orange", 
                        menu:{
                            name:"Manage Expense",
                            items:[
                                {icon:"$invoice-dollar",action:"record_expense",name:"Record Expense"},
                                {icon:"$money-check-dollar",action:"current_expense",name:"Current Expense"},
                                {icon:"$money-check-dollar",action:"manage_expense",name:"Manage Expense"}, 
                            ]
                        }
                    },
                    { 
                        icon:"mdi-text-box-multiple-outline",
                        action:"add_new_customer", 
                        name:"Quotations", 
                        color:"brown", 
                        menu:{
                            name:"Manage Quotation",
                            items:[
                                {icon:"mdi-text-box-search-outline",action:"find_quotation",name:"Find Quotation"},
                                {icon:"mdi-text-box-multiple-outline",action:"issued_quotations",name:"Issued Quotations"},
                                {icon:"mdi-text-box-check",action:"manage_quotations",name:"Manage Quotations"}, 
                            ]
                        }
                    },


                    { 
                        icon:"mdi-account",
                        action:"add_new_customer", 
                        name:"Customers", 
                        color:"", 
                        menu:{
                            name:"Customers",
                            items:[
                                {icon:"mdi-account-plus",action:"add_new_customer",name:"Add New Customer"},
                                {icon:"mdi-account",action:"manage_customers",name:"Manage Customers"}, 
                            ]
                        }
                    }, 
                    { 
                        icon:"mdi-tag",
                        action:"add_new_customer", 
                        name:"Items", 
                        color:"", 
                        menu:{
                            name:"Items",
                            items:[
                                {icon:"mdi-tag-plus",action:"add_new_item",name:"Add New Items"}, 
                                {icon:"mdi-tag",action:"manage_items",name:"Manage Items"},  
                            ]
                        }
                    }, 
                    { 
                        icon:"mdi-group",
                        action:"add_item_kit", 
                        name:"Item Kit", 
                        color:"", 
                        menu:{
                            name:"Item Kit",
                            items:[ 
                                {icon:"mdi-plus-box-outline",action:"add_new_item_kit",name:"Add New Kit/Service"},  
                                {icon:"mdi-group",action:"manage_item_kit",name:"Manage Kit/Services"}, 
                            ]
                        }
                    }, 
                    { 
                        icon:"$printer-pos-pause",
                        action:"close_register", 
                        name:"Close Register",
                        color:"secondary", 
                        type:"sales"
                    }, 
                    {
                        icon:"$printer-pos-plus",
                        action:"start_day", 
                        name:"Start Day",
                        color:"secondary",
                    },
                    {
                        icon:"mdi-order-bool-ascending-variant",
                        action:"manage_shift", 
                        name:"Manage Shift",
                        color:"secondary",
                    },
                    {
                        icon:"$printer-pos-alert" ,
                        action:"x_read", 
                        name:"X Read",
                        color:"secondary",
                        type:"day_shift"
                    },
                    
                    {
                        icon:"$printer-pos-remove",
                        action:"z_read", 
                        name:"Z Read",
                        color:"secondary",
                        type:"day_shift"
                    },
                    { 
                        icon:"mdi-cash-clock",
                        action:"cashup", 
                        name:"Cashup", 
                        color:"", 
                        type:"sales"
                    }, 
                    { 
                        icon:"mdi-sun-clock",
                        action:"days_shifts", 
                        name:"Days Shifts", 
                        color:"", 
                    }, 
                ]
            },
            ActionItems(){ 
                let actions = this.AllActionItems
                let printer = this.AssignedPrinter(null) 
                let isPrinter = printer?true:false
                if(!actions){return null}
                let newActions = actions.filter(item=>{
                    // if (isPrinter) {
                    //     return !item.no_fiscal_printer
                    // }
                    return true
                })
                return newActions
            },
            AssignedPrinter(){
                let till = this.CurrentTill 
                let old_printer = till?till.printer:null
                let assigned_printers = this.MBS.actions.JOIN_PRINTERS(till?till.assigned_printers:null) 
                return (payload)=>{ 
                    const  legal  = payload?.legal
                    const  drawer  = payload?.drawer
                    const  document  = payload?.document 
                    if(!assigned_printers){return old_printer}
                    let printers = [...assigned_printers]
                    const doc_type = document?.doc_type
                    const order = document?.order
                    const departments = order?.joined_items_departments

                    printers.sort(this.MBS.actions.dynamicSort("printer_priority",true))  
                    

                    if (this.MBS.actions.SIZE(departments)) {
                        printers=printers.filter(item=>{
                            if (!this.MBS.actions.SIZE(item.department_codes)||item.department_codes.indexOf('all')!=-1) {
                                return true
                            }
                            const index = departments.findIndex(depart=>item.department_codes.indexOf(depart.code)!=-1)
                            return index==-1?false:true
                        }) 
                        console.log(printers,"printers-dep-------");
                    }
 
                    
                    if (legal) {
                        printers = printers.filter(printer=>
                            printer.printer_option=='print_legal_receipt'||
                            printer.printer_option=='print_all'
                        ) 
                        console.log('111-----------------');
                        
                    }else { 
                        if (doc_type=="bill") {
                            printers = printers.filter(printer=>
                                printer.printer_option=='print_bill'|| 
                                printer.printer_option=='print_nonlegal_receipt'||
                                printer.printer_option=='print_all' 
                            )  
                            // printers.sort(this.MBS.actions.dynamicSort("printer_option",true)) 
                            console.log('222-----------------');
                        } else if (doc_type=="docket") {
                            printers = printers.filter(printer=>
                                printer.printer_option=='print_docket'|| 
                                printer.printer_option=='print_nonlegal_receipt'||
                                printer.printer_option=='print_all' 
                            )  
                            // printers.sort(this.MBS.actions.dynamicSort("printer_option",false)) 
                            console.log('333-----------------');
                        } else {
                            printers = printers.filter(printer=>printer.printer_option!='print_legal_receipt' )  
                        }
                    }  
                    if (drawer==true) {
                        printers = printers.filter(printer=>printer.connect_cash_drawer) 
                        console.log('5555-----------------');
                    } 
                    return printers[0]
                }
            },
            AllowChangingDepartments(){
                const till = this.CurrentTill
                const change = till?till.allow_Cashier_to_change_department:false 
                return change 
            },
            ActionTypesDisabled(){   
                let localCashup = this.LocalCashup
                if (localCashup) {
                    return null
                }
                return  ["sales",]
            }, 
            TillPricingTiers(){
                let till = this.CurrentTill 
                let pricing_tiers = till?till.pricing_tiers:null 
                return pricing_tiers
            },

             
        },
        methods:{ 
            INITIALIZE_PRICING_TIER(){
                try {
                    let pricing_tiers = this.TillPricingTiers
                    if (!pricing_tiers) {
                        
                    } else {
                        this.pricing_tier = pricing_tiers[0]
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INITIALIZE_PRICING_TIER',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ON_SEARCH(pricing_tier){
                try {    
                    if (!pricing_tier) { 
                        this.menu_pricing_tier = true
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_SEARCH',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ON_ITEM_ACTION(value){
                try {    
                    this.MBS.events.$emit("ON_ITEM_ACTION",value)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },

            //---------------[MAIN FUNCTIONS]------------   
             

        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('ON_QR_SCAN', this.ON_QR_SCAN);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);      
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{ 
            search_item(value){
                if(value){
                    setTimeout(() => {
                        this.search_item=null 
                    }, 500);
                    this.$emit("on_search_item",value)
                } 
            }, 
            click_mode(value){
                this.$emit("on_click_mode",value)
            },
            
            SELECTED_ITEMS(value){
                 
            },
            CompanySettings(value){
                if (value) {   
                    this.INITIALIZE_ITEMS_CATEGORIES()
                    this.INITIALIZE_ITEMS_DEPARTMENTS()
                }
            }, 
            selected_departments(value){
                this.ON_UPDATE_DEPARTMENT(value)
                if (value) {   
                    this.INITIALIZE_ITEMS_CATEGORIES() 
                }
            }, 
            
        } 

    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 